import { isLocalStorageAvailable } from '../isLocalStorageAvailable';
import { ALLOWED_TO_SAVE_PROPERTIES, DATA_KEY } from './constants';
export function save(state) {
  if (!isLocalStorageAvailable()) {
    return;
  }
  var keys = Object.keys(state);
  var stateToSave = keys.reduce(function (acc, key) {
    if (ALLOWED_TO_SAVE_PROPERTIES.includes(key)) {
      acc[key] = state[key];
    }
    return acc;
  }, {});
  var preparedState = JSON.stringify(stateToSave);
  window.localStorage.setItem(DATA_KEY, preparedState);
}